import { render } from "./AddRestaurantView.vue?vue&type=template&id=f3a0ad64"
import script from "./AddRestaurantView.vue?vue&type=script&lang=js"
export * from "./AddRestaurantView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\WORK\\Tamani\\admin-landing\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__